/* People and the person page (AdminPeople.dc.html, AdminPerson.dc.html), in the master brand: white,
   the ink, greys as tints of it, gold only for small accents (the progress bar, the alert's bar).
   Every colour is a token (styles/tokens.css). Under 760px every grid becomes 1 column and the tables
   stack (Adam, 4 Oct, answer 5). */

/* ---- People: the panels over the list ------------------------------------------------------------ */
.apl-panel {
  padding: 20px 22px; border-radius: 14px; border: 1px solid var(--shell-ink-16); background: var(--shell-ink-02);
  display: flex; flex-direction: column; gap: 14px;
}
.apl-panel-title { margin: 0; font-size: 16px; font-weight: 800; }
.apl-bulk {
  padding: 22px 24px; border-radius: 14px; border: 1.5px solid var(--shell-ink); background: var(--shell-bg);
  display: flex; flex-direction: column; gap: 18px;
}
.apl-bulk-head { display: flex; justify-content: space-between; align-items: baseline; gap: 6px 16px; flex-wrap: wrap; }
.apl-bulk-title { margin: 0; font-size: 18px; font-weight: 800; }
.apl-grid3 { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.apl-grid2 { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 20px; }
.apl-grid-len { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr); gap: 20px; align-items: end; }
.apl-step { display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.apl-step-label {
  font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60);
}
.apl-source { display: flex; flex-direction: column; gap: 8px; max-width: 640px; }
.apl-inline-field { display: flex; align-items: center; gap: 10px; max-width: 360px; }
.apl-inline-label { font-size: 13px; color: var(--shell-ink-60); flex-shrink: 0; }
.apl-actions { display: flex; align-items: center; gap: 12px 14px; flex-wrap: wrap; }
.apl-hint { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-60); }
.apl-bulk-foot { display: flex; align-items: center; justify-content: space-between; gap: 12px 16px; flex-wrap: wrap; }
.apl-email { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.apl-email .apl-hint { padding-left: 27px; font-size: 12px; }

.apl-ticklist { border-radius: 10px; border: 1px solid var(--shell-ink-10); overflow: hidden; }
.apl-tick {
  display: flex; align-items: center; gap: 4px 12px; padding: 10px 14px; border-bottom: 1px solid var(--shell-ink-06);
  font-size: 14px; flex-wrap: wrap;
}
.apl-tick:last-child { border-bottom: none; }
.apl-tick .ad-check { min-width: 0; }
.apl-tick-name { font-weight: 700; min-width: 160px; display: inline-block; }
.apl-tick-note { color: var(--shell-ink-60); font-size: 14px; }
.apl-tick--skipped .apl-tick-name, .apl-tick--skipped .apl-tick-note { opacity: 0.6; }
.apl-tick--wrong { box-shadow: inset 4px 0 0 var(--shell-ink); }
.apl-tick--wrong .apl-tick-name, .apl-tick--wrong .apl-tick-note { opacity: 1; color: var(--shell-ink); }
.apl-tick-flag { font-weight: 800; }
.apl-tick-empty { margin: 0; padding: 12px 14px; font-size: 14px; color: var(--shell-ink-60); }

/* The boards' small option buttons (For how long, how it was paid for), side by side at their own width */
.apl-compact.ad-options--row .ad-option { flex: 0 1 auto; height: 34px; padding: 0 14px; border-radius: 9px; }

/* ---- People: filters, the list and its count ------------------------------------------------------ */
.apl-filters { display: flex; flex-direction: column; gap: 12px; }
.apl-filter-row { display: flex; gap: 12px 14px; align-items: center; flex-wrap: wrap; }
.apl-name { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.apl-tags { display: flex; flex-wrap: wrap; gap: 5px; }
.apl-tag--outside { background: var(--shell-bg); border: 1px dashed var(--shell-ink-30); }
.apl-count { display: flex; align-items: center; justify-content: space-between; gap: 12px; font-size: 13px; color: var(--shell-ink-60); flex-wrap: wrap; }

/* ---- The person page: who they are --------------------------------------------------------------- */
.apl-person-head { display: flex; align-items: center; justify-content: space-between; gap: 16px 24px; flex-wrap: wrap; }
.apl-who { display: flex; align-items: center; gap: 18px; min-width: 0; }
.apl-avatar {
  width: 64px; height: 64px; border-radius: 32px; background: var(--shell-ink); color: var(--shell-on-ink); flex-shrink: 0;
  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 22px;
}
.apl-who-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.apl-h1 { font-size: 30px; }
.apl-who-line { font-size: 14px; line-height: 1.5; color: var(--shell-ink-62); overflow-wrap: anywhere; }
.apl-who-tags { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 4px; }
.apl-head-actions { display: flex; gap: 10px; flex-wrap: wrap; align-items: flex-start; }

/* The overdue alert, with the gold bar */
.apl-alert {
  display: flex; align-items: center; justify-content: space-between; gap: 12px 20px; padding: 16px 20px; border-radius: 12px;
  background: var(--shell-ink-03); border: 1px solid var(--shell-ink-14); box-shadow: inset 4px 0 0 var(--shell-gold);
}
.apl-alert-text { font-size: 14px; line-height: 1.55; }
.apl-alert-actions { display: flex; gap: 8px; flex-shrink: 0; flex-wrap: wrap; }

/* ---- Access ---------------------------------------------------------------------------------------- */
.apl-access .ad-tr { padding-top: 14px; padding-bottom: 14px; }
.apl-access .ad-thead .ad-tr { padding-top: 10px; padding-bottom: 10px; }
.apl-product { display: flex; align-items: flex-start; gap: 10px; min-width: 0; }
.apl-product .ad-dot { margin-top: 5px; }
.apl-product-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.apl-product-name { font-size: 14px; font-weight: 700; line-height: 1.4; }
.apl-product-detail { font-size: 12px; color: var(--shell-ink-60); }
.apl-cell-line { font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); }
.apl-row-actions { display: inline-flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }
.apl-access-foot { padding: 14px 22px; border-top: 1px solid var(--shell-ink-06); }

.apl-menu { position: relative; display: inline-flex; }
.apl-menu-list {
  position: absolute; right: 0; top: calc(100% + 6px); z-index: 20; min-width: 220px; padding: 6px; border-radius: 10px;
  background: var(--shell-bg); border: 1px solid var(--shell-ink-14); box-shadow: 0 12px 32px var(--admin-dialog-shadow);
  display: flex; flex-direction: column; gap: 2px;
}
.apl-menu-item {
  display: flex; align-items: center; min-height: 38px; padding: 0 12px; border: none; border-radius: 7px; background: none;
  color: var(--shell-ink); font-size: 14px; font-weight: 600; text-align: left; white-space: nowrap;
}
.apl-menu-item:hover, .apl-menu-item:focus-visible { background: var(--shell-ink-04); }

.apl-change { padding: 14px 16px; border-radius: 10px; background: var(--shell-ink-04); display: flex; flex-direction: column; gap: 12px; }
.apl-change-line { margin: 0; font-size: 14px; line-height: 1.5; }
.apl-change-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 280px)); gap: 12px; }

/* ---- Free things --------------------------------------------------------------------------------- */
.apl-free-row { padding: 12px 22px; border-bottom: 1px solid var(--shell-ink-06); display: flex; flex-direction: column; gap: 8px; }
.apl-free-top { display: flex; align-items: center; justify-content: space-between; gap: 14px; }
.apl-free-text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.apl-free-text--held { opacity: 0.6; }
.apl-free-name { font-size: 14px; font-weight: 700; }
.apl-free-line { font-size: 13px; line-height: 1.5; color: var(--shell-ink-66); }
.apl-free-ask { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.apl-free-ask .ad-input { height: 36px; border-radius: 8px; font-size: 13px; flex: 1 1 260px; }
.apl-free-foot { margin: 0; padding: 12px 22px 14px; font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }

/* ---- Progress, logging in, notes ------------------------------------------------------------------ */
.apl-split { display: grid; grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr); gap: 22px; align-items: start; }
.apl-col { display: flex; flex-direction: column; gap: 22px; min-width: 0; }
.apl-prog { display: flex; flex-direction: column; gap: 6px; }
.apl-prog-head { display: flex; justify-content: space-between; gap: 12px; }
.apl-prog-name { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 700; }
.apl-prog-pct { font-size: 13px; font-weight: 700; }
.apl-bar { height: 5px; border-radius: 3px; background: var(--shell-ink-08); }
.apl-bar-fill { height: 5px; border-radius: 3px; background: var(--shell-gold); }
.apl-prog-line { display: flex; align-items: center; justify-content: space-between; gap: 8px 12px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }
.apl-prog-line .ad-btn { flex-shrink: 0; }
.apl-muted { margin: 0; font-size: 14px; color: var(--shell-ink-60); }
/* A member's Start here answers under the product's line (the batch's question 2): read only */
.apl-ans { margin-top: 6px; padding: 12px 14px; border-radius: 9px; background: var(--shell-ink-03); display: flex; flex-direction: column; gap: 10px; }
.apl-ans-top { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 2px 12px; }
.apl-ans-h { margin: 0; font-size: 13px; font-weight: 800; }
.apl-ans-aside, .apl-ans-count { font-size: 12px; line-height: 1.5; color: var(--shell-ink-60); }
.apl-ans-none { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }
.apl-ans-group { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.apl-ans-head { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 2px 12px; }
.apl-ans-name { font-size: 13px; font-weight: 700; }
.apl-ans-value { font-size: 13px; font-weight: 600; }
.apl-ans-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 4px; }
.apl-ans-item { display: grid; grid-template-columns: 16px minmax(0, 1fr); gap: 8px; align-items: start; font-size: 13px; line-height: 1.5; color: var(--shell-ink-72); }
.apl-ans-mark {
  width: 16px; height: 16px; margin-top: 2px; border-radius: 8px; border: 1.5px solid var(--shell-ink-60);
  display: inline-flex; align-items: center; justify-content: center; box-sizing: border-box;
}
.apl-ans-item--on { color: var(--shell-ink); }
.apl-ans-item--on .apl-ans-mark { border-color: var(--shell-ink); background: var(--shell-ink); color: var(--shell-on-ink); }
.apl-ans-text { overflow-wrap: anywhere; }
.apl-login-line { margin: 0; font-size: 14px; line-height: 1.55; color: var(--shell-ink-72); }
.apl-buttons { display: flex; gap: 8px; flex-wrap: wrap; }
.apl-done { margin: 0; font-size: 13px; font-weight: 700; line-height: 1.5; }
.apl-notes .ad-card-body { gap: 12px; }
.apl-notes-line { font-size: 12px; color: var(--shell-ink-60); }
.apl-note { padding: 12px 14px; border-radius: 9px; background: var(--shell-ink-03); display: flex; flex-direction: column; gap: 4px; }
.apl-note-text { font-size: 14px; line-height: 1.5; white-space: pre-line; }
.apl-note-meta { font-size: 12px; color: var(--shell-ink-60); }

/* ---- History ----------------------------------------------------------------------------------- */
.apl-history .ad-card-body { gap: 4px; }
.apl-hist { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; }
.apl-hist-row { display: grid; grid-template-columns: 110px 16px minmax(0, 1fr); gap: 12px; align-items: flex-start; padding: 8px 0; }
.apl-hist-when { font-size: 13px; color: var(--shell-ink-60); font-variant-numeric: tabular-nums; }
.apl-hist-dot { width: 9px; height: 9px; border-radius: 5px; margin-top: 5px; }
.apl-hist-text { font-size: 14px; line-height: 1.5; overflow-wrap: anywhere; }

/* ---- This person ------------------------------------------------------------------------------- */
.apl-this-row { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr); gap: 12px 24px; padding: 18px 22px; border-bottom: 1px solid var(--shell-ink-06); }
.apl-this-row:last-child { border-bottom: none; }
.apl-this-text { display: flex; flex-direction: column; gap: 4px; }
.apl-this-title { margin: 0; font-size: 15px; font-weight: 800; }
.apl-this-body { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
.apl-this-form { display: flex; gap: 8px; align-items: center; }
.apl-this-form .ad-input { flex: 1 1 auto; }
.apl-warning { display: block; margin: 6px 0 0; font-size: 13px; font-weight: 700; line-height: 1.5; }
.apl-old { margin: 0; padding: 0 0 0 18px; font-size: 14px; line-height: 1.6; }
.apl-found { list-style: none; margin: 0; padding: 0; border: 1px solid var(--shell-ink-10); border-radius: 10px; overflow: hidden; }
.apl-found-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 14px; border-bottom: 1px solid var(--shell-ink-06); }
.apl-found-row:last-child { border-bottom: none; }
.apl-found-text { display: flex; flex-direction: column; min-width: 0; }
.apl-found-name { font-size: 14px; font-weight: 700; }
.apl-found-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.apl-hosts { display: flex; flex-direction: column; gap: 8px; }

/* ---- On a phone: each access row 1 line that opens on tap, and History, Referrals and This person folded to their
   headings (the critique's admin 17). The toggle and the fold are drawn only on a phone (usePhone). ------------- */
.apl-row-toggle {
  display: flex; align-items: flex-start; gap: 10px; min-width: 0; flex: 1 1 auto; min-height: 24px; padding: 0; margin: 0;
  border: 0; background: none; color: inherit; font: inherit; text-align: left; cursor: pointer;
}
.apl-chev {
  flex: none; width: 8px; height: 8px; margin: 6px 4px 0 auto; border-right: 2px solid var(--shell-ink); border-bottom: 2px solid var(--shell-ink);
  transform: rotate(45deg);
}
.apl-row-toggle[aria-expanded="true"] .apl-chev { transform: rotate(-135deg); margin-top: 9px; }
.apl-fold--phone { border: 1px solid var(--shell-ink-10); border-radius: 14px; background: var(--shell-bg); }
.apl-fold-head[hidden] { display: none; }
.apl-fold-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 52px; padding: 0 16px; cursor: pointer; list-style: none; }
.apl-fold-head::-webkit-details-marker { display: none; }
.apl-fold-head::after {
  content: ""; flex: none; width: 8px; height: 8px; margin-right: 4px; border-right: 2px solid var(--shell-ink); border-bottom: 2px solid var(--shell-ink);
  transform: rotate(45deg) translateY(-2px);
}
.apl-fold[open] > .apl-fold-head::after { transform: rotate(-135deg) translateY(-2px); }
.apl-fold-title { margin: 0; }
/* the card inside the fold keeps its heading for screen readers and its name, out of sight: the fold's heading says it */
.apl-fold--phone > .ad-card { position: relative; border: 0; border-top: 1px solid var(--shell-ink-06); border-radius: 0 0 14px 14px; box-shadow: none; }
.apl-fold--phone > .ad-card > .ad-card-head {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}

/* The grant dialog's button runs the dialog's width, as the board draws it */
.ad-dialog-foot .apl-grant-go { width: 100%; height: 46px; border-radius: 10px; font-size: 15px; }

/* ---- Between laptop and phone, and on a phone ------------------------------------------------------ */
@media (max-width: 1100px) {
  .apl-split { grid-template-columns: minmax(0, 1fr); }
  .apl-grid3 { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
}
@media (max-width: 760px) {
  .apl-panel, .apl-bulk { padding: 16px; }
  .apl-grid3, .apl-grid2, .apl-grid-len, .apl-change-fields, .apl-this-row { grid-template-columns: minmax(0, 1fr); }
  .apl-inline-field { max-width: none; }
  .apl-bulk-foot { flex-direction: column; align-items: stretch; }
  .apl-bulk-foot .apl-actions { justify-content: space-between; }
  .apl-who { align-items: flex-start; gap: 14px; }
  .apl-avatar { width: 52px; height: 52px; border-radius: 26px; font-size: 18px; }
  .apl-h1 { font-size: 26px; }
  .apl-head-actions { width: 100%; }
  .apl-alert { flex-direction: column; align-items: stretch; }
  .apl-row-actions { justify-content: flex-start; }
  .apl-menu-list { left: 0; right: auto; }
  .apl-free-row, .apl-free-foot { padding-left: 16px; padding-right: 16px; }
  .apl-free-top { align-items: flex-start; }
  .apl-prog-line { flex-direction: column; align-items: flex-start; }
  .apl-ans { padding: 12px; }
  .apl-hist-row { grid-template-columns: 76px 12px minmax(0, 1fr); gap: 8px; }
  .apl-this-row { padding: 16px; }
  .apl-this-form { flex-direction: column; align-items: stretch; }
  .apl-access-foot { padding: 14px 16px; }
  .apl-tick-name { min-width: 0; }
  /* a shut row: its product and status on 1 line, the rest hidden until it's tapped open */
  .apl-access .ad-tr:has(.apl-row--shut) { flex-direction: row; align-items: center; justify-content: space-between; gap: 10px; }
  .apl-access .ad-tr:has(.apl-row--shut) > .ad-td:first-child { flex: 1 1 auto; min-width: 0; }
  .apl-access .ad-tr:has(.apl-row--shut) > .ad-td:nth-child(2) { flex: none; }
  .apl-access .ad-tr:has(.apl-row--shut) > .ad-td:nth-child(2)::before { display: none; }
  .apl-access .ad-tr:has(.apl-row--shut) > .ad-td:nth-child(n+3) { display: none; }
}

/* A replay's register pages on the person page (docs/replay-register-spec.md 5) */
.apl-register-line { margin: 0 0 8px; font-size: 14px; font-weight: 700; line-height: 1.5; }
.apl-register-list { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 6px; }
.apl-register-list li { font-size: 14px; line-height: 1.5; color: var(--shell-ink-80); overflow-wrap: anywhere; }
